// Importación de Axios
import axios from "axios";
import { RUTA_SERVIDOR_BACKEND } from "./configuraciones";

/*  

Sección Modulos 

*/

export const getModulos = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/modulos`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveModulos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/modulos`,
      {
        name: data.nombreModel,
        icon: data.iconoModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateModulos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/modulos`,
      {
        id: data.id,
        name: data.nombreModel,
        icon: data.iconoModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteModulo = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/modulos/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const activarDesactivarModulo = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/activarDesactivarModulo`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/*

...:::: Secciones ::::...


*/

// Obtener Secciones
export const getSecciones = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarSecciones`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

// Obtener SubSecciones
export const getSubSecciones = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarSubSecciones`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveSeccion = async (data) => {
  let dataResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearSeccion`,
      {
        name: data.nombreModel,
        name_reference: data.referenciaModel,
        id_module: data.moduloModel.id,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push({ data: dataResponse });

  return dataAux[0];
};

export const updateSeccion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarSeccion`,
      {
        id: data.id,
        name: data.nombreModel,
        name_reference: data.referenciaModel,
        id_module: data.moduloModel.id,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteSeccion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarSeccion/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const saveSubSeccion = async (data) => {
  let dataResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearSubSeccion`,
      {
        name: data.name,
        id_parent: data.id_parent,
        name_reference: data.name_reference,
        id_module: data.id_module,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push({ data: dataResponse });

  return dataAux[0];
};

export const updateSubSeccion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarSubSeccion`,
      {
        id: data.id,
        name: data.name,
        id_parent: data.id_parent,
        name_reference: data.name_reference,
        id_module: data.id_module,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const activarDesactivarSubSeccion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/activarDesactivarSubSeccion`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteSubSeccion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarSeccion/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const activarDesactivarSeccion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/activarDesactivarSeccion`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/*




...:::: Permisos por roles ::::...

*/

export const getPermisosRoles = () => 
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarPermisosRoles`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveRolStructure = async (data) => {
  const result = await axios.post(`${RUTA_SERVIDOR_BACKEND}/crearRolStructure`, { data }, {
    headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  return result;
};

export const removeRolStructure = async ( id ) => { //change the id_status from the sys_roles_structure table
  try {
    await axios.post(`${RUTA_SERVIDOR_BACKEND}/removeRolStructure`, { id: id }, {
      headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
  } catch (err) {
    console.log(`'${err}' , please contact backend support.`);
  }
}

export const updatePermissions = async (data, tipo) => {
  let dataResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/permisos`,
      {
        data,
        tipo
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
    });

  dataAux.push({ data: dataResponse });

  return dataAux[0];
};

export const getModulesSections = async () => (
  await axios.get(`${RUTA_SERVIDOR_BACKEND}/getModulesSections`,{
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
);

export const createRolStructureByUser = async ( payload ) => (
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/createRoleStructureByUser`, payload, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
);

export const createRole = async ( payload ) => (
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/createRole`, payload, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
);

export const getUserTransitions = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/userTransitions`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const removeRole = async ( payload ) => (
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/removeRole`, payload, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
);

export const changeRoleStatus = async ( payload ) => (
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/changeRoleStatus`, payload, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
);

